<app-form-header class="backoffice-page-header"></app-form-header>
<app-list-table [tableColumns]="tableColumns"
                [tableData]="lista"
                [serverList]="service"
                (editarEmitter)="editar($event)"
                (verEmitter)="ver($event)"
                [btnBorrar]="true"
                (borrarEmitter)="eliminar($event)" [reinicio]="eventsSubject.asObservable()">
</app-list-table>
